


















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ListLayout extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/listlayout/ListLayout.vue